export default (o, c, d) => {
  c.prototype.isYesterday = function () {
    const yesterday = window.dayjs.yesterday()
    return this.isSame(yesterday, 'date')
  }
}
